import styled from 'styled-components';
import { media } from '@pik/pik-ui';

export const Container = styled.div`
  display: flex;
  padding: 18px 0;
  border-bottom: 1px solid #E1E1E1;
  
  &:last-child {
    border-bottom: none;
  }
  
  .StockButton {
    margin-top: 22px;
    
    svg {
      margin-right: 6px;
    }
  }
  
  @media ${media.max768} {
    display: block;   
    border-bottom: none;
    padding: 32px 0;
    
    .StockButton {
      margin-top: 8px;
    }
    
    ${({ isFirst }) => (isFirst ? 'padding-top: 0;' : '')}
  }
`;

export const MainContainer = styled.div`
  min-width: 160px;
  padding-top: 16px;
  padding-right: 128px;
  
  @media ${media.max768} {
    min-width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 64px;

    &:first-child {
      padding-top: 0;
    }
  }
`;

export const MainWrapper = styled.div`
  @media ${media.max768} {
    display: flex;
    flex-direction: column;
  }
`;

export const Paper = styled.span`
  display: block;
  font-family: Graphik;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #222222;
  
`;

export const CouponRate = styled.span`
  font-family: Graphik;
  font-weight: 500;
  font-size: 32px;
  line-height: 38px;
  color: #222222;
  
  ${({ isPrefix }) => !!isPrefix && 'font-size: 20px;'}
  
  @media ${media.max768} {
    font-size: 32px;
    line-height: 38px;
    font-weight: 500;
  }
`;

export const CouponRateWrapper = styled.div`
  margin-top: 7px;
  
`;

export const Volume = styled.span`
  display: block;
  font-family: Graphik;
  font-size: 14px;
  line-height: 18px;
  color: #808080;
  margin-top: 8px;
  
`;

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  
  @media ${media.max768} {
    margin-top: 0;
  }
`;

export const InfoRow = styled.div`
  width: 46%;
  display: flex;  
  justify-content: space-between;
  border-bottom: 1px solid #E1E1E1;
  padding: 15px 0;
  box-sizing: border-box;
  
  &:last-child, &:nth-child(7) {
    border-bottom: none;
  }
  
  @media ${media.max768} {
    width: 100%;
    border-bottom: 1px solid #E1E1E1;
    padding: 16px 0;
    
    
    
    &:nth-child(2) {
      order: 1;
      margin-top: 32px;
    }

    &:nth-child(4) {
      order: 2;
    }

    &:nth-child(6) {
      order: 3;
    }
    
    &:last-child(7) {
      border-bottom: none;
    }
  }
`;

export const InfoName = styled.span`
  font-family: Graphik;
  font-size: 16px;
  line-height: 24px;
  color: #222222;
  letter-spacing: 0;
`;

export const InfoValue = styled.span`
  font-family: Graphik;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #222222;
  padding-right: 32px;
  text-align: right;
  
  @media ${media.max1024} {
    padding-right: 0;
  }
`;
